import React from 'react';

const NotExistPage = () => {
    return (
        <div className="content-wrapper">
            Not Exist Url
        </div>
    );
};

export default NotExistPage;